import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/partyOrganization/list',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/partyOrganization/insert',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/partyOrganization/get',
    method: 'post',
    data: data
  });
}
export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/partyOrganization/delete',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/partyOrganization/update',
    method: 'post',
    data: data
  });
}
export function fetchDict(data) {
  return request({
    url: '/userservice/api/dict/list',
    method: 'post',
    data: data
  });
}
export function dependencyDic(data) {
  return request({
    url: '/pmsservice/api/partyBranch/dependencyDic',
    method: 'post',
    data: data
  });
}